import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <Link to="/" className="logo">
            <img src="/logo.png" alt="DHRTI MAA" className="logo-img" />
            <div className="logo-text">
              <h1 className="logo-title">DHRTI MAA</h1>
              <p className="logo-tagline">Inspired By Nature</p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            <ul className="nav-list">
              <li className="nav-item">
                <Link to="/" className="nav-link">Home</Link>
              </li>
              <li className="nav-item">
                <Link to="/about" className="nav-link">About</Link>
              </li>
              <li className="nav-item">
                <Link to="/products" className="nav-link">Products</Link>
              </li>
              <li className="nav-item">
                <Link to="/blog" className="nav-link">Blog</Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link">Contact</Link>
              </li>
            </ul>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            className="mobile-menu-btn"
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span className={`hamburger ${isMenuOpen ? 'active' : ''}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav className={`nav-mobile ${isMenuOpen ? 'active' : ''}`}>
          <ul className="nav-list-mobile">
            <li className="nav-item-mobile">
              <Link to="/" className="nav-link-mobile" onClick={toggleMenu}>Home</Link>
            </li>
            <li className="nav-item-mobile">
              <Link to="/about" className="nav-link-mobile" onClick={toggleMenu}>About</Link>
            </li>
            <li className="nav-item-mobile">
              <Link to="/products" className="nav-link-mobile" onClick={toggleMenu}>Products</Link>
            </li>
            <li className="nav-item-mobile">
              <Link to="/blog" className="nav-link-mobile" onClick={toggleMenu}>Blog</Link>
            </li>
            <li className="nav-item-mobile">
              <Link to="/contact" className="nav-link-mobile" onClick={toggleMenu}>Contact</Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
